<mat-card class="mb-25 tagus-card">
    <mat-card-header class="border-bottom">
        <h5 class="mb-0">Overview</h5>
        <button type="button" mat-button class="position-relative btn bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
            This Week
        </button>
        <mat-menu #monthMenu="matMenu" class="monthMenu" xPosition="before">
            <button mat-menu-item type="button" class="bg-transparent border-none">This Month</button>
            <button mat-menu-item type="button" class="bg-transparent border-none">This Year</button>
            <button mat-menu-item type="button" class="bg-transparent border-none">All Time</button>
        </mat-menu>
    </mat-card-header>
    <mat-card-content>
        <div class="chart hoursSpentChart">
            <apx-chart
                [series]="chartOptions.series!"
                [chart]="chartOptions.chart!"
                [dataLabels]="chartOptions.dataLabels!"
                [plotOptions]="chartOptions.plotOptions!"
                [tooltip]="chartOptions.tooltip!"
                [yaxis]="chartOptions.yaxis!"
                [grid]="chartOptions.grid!"
                [xaxis]="chartOptions.xaxis!"
                [colors]="chartOptions.colors!"
                [legend]="chartOptions.legend!"
                [fill]="chartOptions.fill!"
                [title]="chartOptions.title!"
            ></apx-chart>
        </div>
    </mat-card-content>
</mat-card>